import { Button } from 'components/Button';
import { IconCross } from 'components/Shared/Icon/themes/BGH-RD3/iconCross';
import Modal from 'components/Shared/Modal';
import { CustomerOrder } from 'models/CustomerOrder';
import { useSelector } from 'react-redux';
import { rm } from 'utils';
import {
  selectChangesPageUrl,
  selectClaimsPageUrl,
  selectContactUrl,
  selectDeliveriesPageUrl,
  selectPaymentsPageUrl,
  selectPriceMatchPageUrl,
  selectRentalPageUrl,
  selectReturnsPageUrl,
  selectShippingDamagePageUrl
} from '../selectors';
import { HelpArea } from './HelpArea';
import styles from './styles.scss';

interface OwnProps {
  className?: string;
  show: boolean;
  toggle: () => void;
  order: CustomerOrder;
}

export const HelpModal = ({ show, toggle, order }: OwnProps) => {
  const genericContactPageUrl = useSelector(selectContactUrl);
  const returnPageUrl = useSelector(selectReturnsPageUrl);
  const paymentsPageUrl = useSelector(selectPaymentsPageUrl);
  const claimsPageUrl = useSelector(selectClaimsPageUrl);
  const changesPageUrl = useSelector(selectChangesPageUrl);
  const deliveriesPageUrl = useSelector(selectDeliveriesPageUrl);
  const rentalPageUrl = useSelector(selectRentalPageUrl);
  const shippingDamagePageUrl = useSelector(selectShippingDamagePageUrl);
  const priceMatchPageUrl = useSelector(selectPriceMatchPageUrl);
  
  return (
    <Modal
      show={show}
      contentClassName={styles.modal}
      disableOverlay={false}
      overlayClassName={styles.modalOverlay}
      onClose={toggle}
    >
      <div className={styles.header}>
        <h2>{rm('customerpage_helpmodal_header')}</h2>
        <Button appearance="link" onClick={toggle}>
          <IconCross />
        </Button>
      </div>
      <div>
        <p>{rm('customerpage_helpmodal_body')}</p>
        <HelpArea
          header={rm('customerpage_helpmodal_return_header')}
          body={rm('customerpage_helpmodal_return_body')}
          button={rm('customerpage_helpmodal_return_button')}
          href={
            returnPageUrl !== ''
              ? `${returnPageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}?startForm=return`
          }
        />
        <HelpArea
          header={rm('customerpage_helpmodal_complaint_header')}
          body={rm('customerpage_helpmodal_complaint_body')}
          button={rm('customerpage_helpmodal_complaint_button')}
          href={
            claimsPageUrl !== ''
              ? `${claimsPageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}?startForm=complaints`
          }
        />
        <HelpArea
          header={rm('customerpage_helpmodal_shipping_damage_header')}
          body={rm('customerpage_helpmodal_shipping_damage_body')}
          button={rm('customerpage_helpmodal_shipping_damage_button')}
          href={
            shippingDamagePageUrl !== ''
              ? `${shippingDamagePageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}`
          }
        />
        <HelpArea
          header={rm('customerpage_helpmodal_delivery_header')}
          body={rm('customerpage_helpmodal_delivery_body')}
          button={rm('customerpage_helpmodal_delivery_button')}
          href={
            deliveriesPageUrl !== ''
              ? `${deliveriesPageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}?startForm=delivery`
          }
        />
        <HelpArea
          header={rm('customerpage_helpmodal_payment_header')}
          body={rm('customerpage_helpmodal_payment_body')}
          button={rm('customerpage_helpmodal_payment_button')}
          href={
            paymentsPageUrl !== ''
              ? `${paymentsPageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}?startForm=payment`
          }
        />
        <HelpArea
          header={rm('CustomerService_Question_Category_Price_Match')}
          body={rm('customerpage_helpmodal_price_match_body')}
          button={rm('CustomerService_Question_Category_Price_Match')}
          href={
            priceMatchPageUrl !== ''
              ? `${priceMatchPageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}?startForm=price-match`
          }
        />
        <HelpArea
          header={rm('customerpage_helpmodal_change_header')}
          body={rm('customerpage_helpmodal_change_body')}
          button={rm('customerpage_helpmodal_change_button')}
          href={
            changesPageUrl !== ''
              ? `${changesPageUrl}?order=${order.orderNumber}`
              : `${genericContactPageUrl}?startForm=orderchange`
          }
        />
        {order?.includesRentalProduct && (
          <HelpArea
            header={rm('customerpage_helpmodal_rental_header')}
            body={rm('customerpage_helpmodal_rental_body')}
            button={rm('customerpage_helpmodal_rental_button')}
            href={rentalPageUrl !== '' ? rentalPageUrl : `${genericContactPageUrl}`}
          />
        )}
      </div>
    </Modal>
  );
};
